import { VuexModule, Module, Mutation } from "vuex-module-decorators";
import { store } from "commonui";
import { AppViewMode, ApplicationViews } from "@/util/enum";
import { AppSettingsModel } from "@/util/constants";

@Module({ namespaced: true, dynamic: true, store: store, name: "appsettings" })
class AppSettings extends VuexModule {
	public isNavigationCollapsed: boolean = false;
	public mode = AppViewMode.Blank;
	public appMenuSelected = ApplicationViews.WordCount;
	public menuCategory = 0;
	public childMenuSelected = ApplicationViews.Dashboard;
	public versionManagerVisible = false;
	public appBreadCrumbVisible = false;
	public settings: AppSettingsModel = this.getDefaults();

	@Mutation
	setMenuCategory(value: number) {
		this.menuCategory = value ? value : 0;
	}

	@Mutation
	setAppMode(val: AppViewMode): void {
		this.mode = val;
	}

	@Mutation
	setAppMenu(val: ApplicationViews): void {
		this.appMenuSelected = val;
	}

	@Mutation
	setChildMenu(val: ApplicationViews): void {
		this.childMenuSelected = val;
	}

	@Mutation
	setMangerVisible(visible: boolean) {
		this.versionManagerVisible = visible;
	}

	@Mutation
	setAppBreadCrumbVisible(visible: boolean) {
		this.appBreadCrumbVisible = visible;
	}

	@Mutation
	setAppSettings(settings: AppSettingsModel): void {
		this.settings = settings;
	}

	@Mutation
	setNavigationCollapse(collapsed: boolean): void {
		this.isNavigationCollapsed = collapsed;
	}

	private getDefaults(): AppSettingsModel {
		return {
			version: "V6.6",
			copyRightYear: new Date().getFullYear() + ""
		};
	}
}
export default AppSettings;
